<form *transloco="let t" class="grid gap-4 py-2 md:grid-cols-2" [formGroup]="form">
  <label class="md:col-span-2" tuiLabel>
    {{ t("Numéro d'identification") }}
    <tui-textfield>
      <input data-testid="patient-business-identifier" formControlName="businessIdentifier" maxlength="64" tuiInput />
    </tui-textfield>
  </label>

  <label tuiLabel>
    {{ t('Nom') }}
    <tui-textfield>
      <input data-testid="patient-last-name" formControlName="lastName" maxlength="255" tuiInput />
    </tui-textfield>
  </label>

  <label tuiLabel>
    {{ t('Prénom') }}
    <tui-textfield>
      <input data-testid="patient-first-name" formControlName="firstName" maxlength="255" tuiInput />
    </tui-textfield>
  </label>

  <label tuiLabel>
    {{ t('Nom de naissance') }}
    <tui-textfield>
      <input data-testid="patient-birth-name" formControlName="birthName" maxlength="255" tuiInput />
    </tui-textfield>
  </label>

  <label tuiLabel>
    {{ t('Date de naissance') }}
    <tui-textfield>
      <input data-testid="patient-birth-date" formControlName="birthDate" tuiInputDate />
      <tui-calendar *tuiDropdown />
    </tui-textfield>
  </label>
</form>
